import React, { useState } from 'react'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import ICalendar from "assets/i-calendar";
import ICarret from 'assets/i-carret';
import cn from "classnames";

const SelectDateRange = ({ startDate, endDate, onChange, placeholder = "Select Date Range", disabled = false }) => {
  const [dateRange, setDateRange] = useState([startDate || null, endDate || null]);
  const [start, end] = dateRange;

  const handleChange = (update) => {
    setDateRange(update);
    if (onChange) {
      onChange(update);
    }
  };

  const formatDateRange = () => {
    if (start && end) {
      const formatDate = (date) => {
        const day = date.getDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
      };
      return `${formatDate(start)} - ${formatDate(end)}`;
    }
    return placeholder;
  };

  return (
    <div className={cn("relative inline-block", disabled && "opacity-50 cursor-not-allowed")}>
      <DatePicker
        selectsRange={true}
        startDate={start}
        endDate={end}
        onChange={handleChange}
        dateFormat="dd MMM yyyy"
        disabled={disabled}
        customInput={
          <button
            disabled={disabled}
            type="button"
            className={cn("h-[24px] flex items-center gap-1 rounded-[4px] border border-solid border-[#D8D8D9] px-2", disabled && "disabled:bg-[#FAFAFA] cursor-not-allowed")}
          >
            <ICalendar />
            <span className="text-[11px] font-inter">{formatDateRange()}</span>
            <div className="rotate-90">
              <ICarret />
            </div>
          </button>
        }
      />
    </div>
  );
};

export default SelectDateRange;